import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M36 32V40H20V32H36ZM48 20C48 13.3726 42.6274 8 36 8H20C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32V40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 2.57703e-07 20 0H36L36.5166 0.00683594C47.3235 0.280845 56 9.12703 56 20C56 30.873 47.3235 39.7192 36.5166 39.9932L36 40V32C42.6274 32 48 26.6274 48 20Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 40

/**
 * Round rect cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */

export const RoundRectCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default RoundRectCutoutShape
